import { Injectable, Optional } from '@angular/core';
export class AccountConfigServiceOption {
  options?: any;
  routingBaseUri?: string;
  themingClassName?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AccountConfigService {
  private _options = null;
  private _routingBaseUri = '';
  private _themingClassName = '';
  public get routingBaseUri(): string {
    return this._routingBaseUri.toString();
  }
  public set routingBaseUri(value: string) {
    this._routingBaseUri = value;
  }

  public get themingClassName(): string {
    return this._themingClassName;
  }

  constructor(@Optional() config: AccountConfigServiceOption) {
    if (config) {
      this._options = config.options;
      this._routingBaseUri = config.routingBaseUri || '';
      this._themingClassName = config.themingClassName || '';
    }
  }

  setOptions(value) {
    this._options = value;
  }

  getOptions() {
    return this._options;
  }
}
